import $ from "jquery";
import {FormValidation} from "./FormValidation";

$(function () {
    const mapping = {
        personal_data: [
            {
                name: 'personal_data[Title]',
                label: 'Aanhef',
                type: 'select',
            },
            {
                name: 'personal_data[firstname]',
                label: 'Voornaam'
            },
            {
                name: 'personal_data[insertion]',
                label: 'Tussenvoegsel'
            },
            {
                name: 'personal_data[lastname]',
                label: 'Achternaam'
            },
            {
                name: 'personal_data[Email]',
                label: 'E-mail'
            },
            {
                name: 'personal_data[Telephone]',
                label: 'Telefoon'
            }
        ],
        vehicle_data: [
            {
                name: 'vehicle_data[Kenteken]',
                label: 'Kenteken'
            },
            {
                name: 'vehicle_data[Kilometerstand]',
                label: 'Kilometerstand'
            },
            {
                name: 'vehicle_data[Brandstof]',
                label: 'Brandstof'
            },
            {
                name: 'vehicle_data[Bouwjaar]',
                label: 'Bouwjaar'
            },
            {
                name: 'vehicle_data[Transmissie]',
                label: 'Transmissie'
            },
            {
                name: 'vehicle_data[Pakketten][]',
                label: 'Pakketten',
                type: 'count',
            },
            {
                name: 'vehicle_data[Opties][]',
                label: 'Opties',
                type: 'count',
            },
            {
                name: 'vehicle_data[ConditieExterieur]',
                label: 'Staat exterieur',
                type: 'select',
            },
            {
                name: 'vehicle_data[ConditieInterieur]',
                label: 'Staat interieur',
                type: 'select',
            },
            {
                name: 'vehicle_data[StaatMotor]',
                label: 'Staat motor',
                type: 'select',
            },
            {
                name: 'vehicle_data[isBTWVoertuig]',
                label: 'Marge/BTW',
                type: 'select',
            },
            {
                name: 'vehicle_data[OnderhoudData]',
                label: 'Datum laatste onderhoud',
            },
            {
                name: 'vehicle_data[OnderhoudKilometerstand]',
                label: 'Kilometerstand laatste onderhoud',
            },

            {
                name: 'vehicle_data[AantalSleutels]',
                label: 'Aantal sleutels'
            },
            {
                name: 'vehicle_data[Interieurkleur]',
                label: 'Kleur interieur'
            },
            {
                name: 'vehicle_data[Usage]',
                label: 'Gebruikssporen'
            },
        ],
        interest_data: [
            {
                name: 'interest_data[type]',
                label: 'Interesse in'
            },
            {
                name: 'interest_data[brand]',
                label: 'Merk'
            },
            {
                name: 'interest_data[model]',
                label: 'Model'
            },
        ]
    }

    const form = document.querySelector('form[name="taxatiemodule_singup"]');
    if (form) {
        new FormValidation($(form), {
            inputGroup: 'input-wrapper',
            invalidClass: 'is-invalid',
            loading: '<i class="fa fa-spinner fa-spin mx-auto"></i>',
            button: form.querySelector('button'),
            ajax: false
        });
    }

    const taxatie_form = document.getElementsByClassName('taxatiemodule-form');
    if (taxatie_form.length) {
        const $form = $(taxatie_form);

        const taxatieFormValidator = new FormValidation($form, {
            inputGroup: 'input-wrapper',
            invalidClass: 'is-invalid',
            loading: '<i class="fa fa-spinner fa-spin mx-auto"></i>',
            button: taxatie_form[0].querySelector('.submit_taxatie'),
            disableSubmit: true,
            onSubmitSuccess: function (res) {
                const currentStep = $form.find("[data-index=5]");
                const prevStep = $form.find("[data-index=6]");

                // Hide current step
                toggleStep(currentStep, visible, hidden);
                // Show previous step
                toggleStep(prevStep, hidden, visible);
                // Update step index
                toggleStepIndex('next', currentStep);
            }
        });

        const btn_prev = $form.find('[data-prev-step]');
        const btn_next = $form.find('[data-next-step]');
        const visible = "step-visible";
        const hidden = "step-hidden";
        const stepper = $form.find('.stepper');
        const index = stepper.find('.step').first().data('index');
        const showStepClickFunction = function (e) {
            e.preventDefault();
            const $this = $(this);
            const step = $this.data('show-step');
            const currentStep = $(document.getElementsByClassName(visible)[0]);
            const prevStep = $form.find("[data-index=" + step + "]");

            // Hide current step
            toggleStep(currentStep, visible, hidden);
            // Show previous step
            toggleStep(prevStep, hidden, visible);
            // Update step index
            toggleStepIndex('prev', prevStep);
        }

        btn_next.on('click', function (e) {
            e.preventDefault();
            const $this = $(this);
            if ($this.hasClass('validate')) {
                if (!taxatieFormValidator.formValidate.form()) {
                    return;
                }
            }

            if ($this.hasClass('check_uploads')) {
                let minFiles = $('.taxatie-dropzone').length;
                let totalFiles = 0;
                let errorField = $('.taxatie-file-upload-error');

                $(".taxatie-dropzone").each(function () {
                    totalFiles += this.dropzone.files.length;
                });

                if (totalFiles < minFiles) {
                    errorField.html("Upload minimaal " + minFiles + " bestanden");
                    return;
                } else {
                    errorField.html("");
                }
            }

            const currentStep = $this.closest(".step");
            const nextStep = currentStep.next();

            // // Hide current step
            toggleStep(currentStep, visible, hidden);
            // // Show next step
            toggleStep(nextStep, hidden, visible);
            // // Update step index
            toggleStepIndex('next', currentStep);
        });

        btn_prev.on('click', function (e) {
            e.preventDefault();
            const $this = $(this);
            const currentStep = $this.closest("[data-step]");
            const prevStep = currentStep.prev();

            // Hide current step
            toggleStep(currentStep, visible, hidden);
            // Show previous step
            toggleStep(prevStep, hidden, visible);
            // Update step index
            toggleStepIndex('prev', prevStep);
        });

        $('[data-show-step]').on('click', showStepClickFunction);

        // Process the selected data
        $('.check-data').on('click', function () {
            const formFields = {};
            $.each($form.serializeArray(), function () {
                formFields[this.name] = this.value;
            });

            // Map formFields to groups (vehicle_data, personal_data, interest_data)
            for (const section in mapping) {
                const $target = $form.find('.' + section + ' > .list');
                $target.empty();
                $.each(mapping[section], function () {
                    let value;
                    switch (this.type) {
                        case 'count':
                            value = formFields[this.name] && formFields[this.name].length || '';
                            break;
                        case 'select':
                            const selectedOption = $(`select[name="${this.name}"] option[value="${formFields[this.name]}"]`)[0];
                            value = selectedOption.innerHTML || '';
                            break;
                        default:
                            value = formFields[this.name] || '';
                            break;
                    }
                    $target.append(`<div class="list-item"><span class="item-label">${this.label}</span>${value}</div>`);
                });
            }
        });

        $('.submit_taxatie').on('click', function () {
            taxatieFormValidator.config.disableSubmit = false;
            taxatieFormValidator.setValidation();
            taxatieFormValidator.formValidate.form();
        });

        $('.single-select').on('click', function () {
            const $this = $(this);
            const $input = $this.find('input');
            const inputs = $form.find('input[name="' + $input.attr('name') + '"]');
            const checkedState = $input.prop('checked');
            inputs.prop('checked', false);
            $input.prop('checked', checkedState);
        });

        function toggleStep(elem, remove, add) {
            if (elem.hasClass(remove)) {
                elem.removeClass(remove);
                elem.addClass(add);
            }
        }

        function toggleStepIndex(action, elem) {
            const teller = document.querySelectorAll("[data-step-index]");
            let currentIndex = parseInt(elem.data('index')) + index;

            if (action === 'prev') {
                currentIndex = parseInt(elem.data('index'));
            }

            teller.forEach(function (index) {
                const $item = $(index);
                const stepIndex = $item.data('stepIndex');

                if (stepIndex === currentIndex) {
                    $item.removeClass("cursor-pointer");
                    $item.removeClass(hidden);
                    $item.addClass(visible);
                } else if (stepIndex < currentIndex || stepIndex > currentIndex) {
                    $item.removeData('showStep');
                    $item.unbind('click');
                    $item.removeClass("cursor-pointer");

                    if (currentIndex !== 6 && stepIndex < currentIndex) {
                        $item.attr('data-show-step', stepIndex);
                        $item.on('click', showStepClickFunction);
                        $item.addClass("cursor-pointer");
                    }

                    $item.removeClass(visible);
                    $item.addClass(hidden);
                }
            });
        }

        let interestTypes = $("input[name='interest_data[type]']")
        interestTypes.on('change', function () {
            interestTypes.each(function (index, interestType) {
                interestType = $(interestType);
                let brand = $("input[name='interest_data[brand]']");

                if (interestType.val() === "Nieuwe auto" && interestType.prop('checked')) {
                    let model = $("input[name='interest_data[model]']");

                    brand.val(brand.data('default'));
                    brand.prop('readonly', true);

                    let modelListHtml = "";
                    brand.data("models").forEach(function (model) {
                        modelListHtml += "<option value='" + model + "'>" + model + "</option>";
                    });

                    if (model.parent().attr('class') === "input input--default") {
                        model.parent().replaceWith(model);
                    }

                    model.replaceWith(
                        "<div class=\"select select--default\">" +
                            "<label>Model</label>" +
                            "<div class=\"select\">" +
                                "<select name='interest_data[model]'>" + modelListHtml + "</select>" +
                                "<i class=\"ion-chevron-down\"></i>" +
                            "</div>" +
                        "</div>"
                    )
                } else if (interestType.val() === "Gebruikte auto" && interestType.prop('checked')) {
                    let model = $("select[name='interest_data[model]']");

                    brand.prop('readonly', false);

                    if (model.parent().parent().attr('class') === "select select--default") {
                        model.parent().parent().replaceWith(model);
                    }

                    model.replaceWith(
                        "<div class=\"input input--default\">" +
                            "<label class='input--label'>Model</label>" +
                            "<input type='text' name='interest_data[model]' value='" + model.val() + "'/>" +
                        "</div>"
                    );
                }
            })
        });
    }
});
